import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";
import { MARQUEE_EN, useLang } from "@/i18n";

export const Ribbon = () => {
  const { lang } = useLang();
  const items = lang === "en" ? MARQUEE_EN : MARQUEE_ITEMS;
  return (
    <div data-testid="editorial-ribbon" className="border-y border-gold/30 bg-black py-5 overflow-hidden">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8 text-sm uppercase tracking-[0.3em] text-gold font-light">{item}</span>
            <span className="text-gold/50 text-xs">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
